import React from "react";
import { Box, Typography } from "@mui/material";

export interface IlingnunUkpiginHeaderInfoProps {}

export function IlingnunUkpiginHeaderInfo({}: IlingnunUkpiginHeaderInfoProps) {
  return (
    <Box>
      <Box mb={4}>
        <Typography variant="h3" textAlign="center">
          ILINGNUN UKPIGIN: Personal and Health Information Disclosure Form
        </Typography>
      </Box>

      <Typography variant="h4" paragraph>
        INFORMATION ABOUT THIS FORM
      </Typography>
      <Typography paragraph>
        <b>PURPOSE OF COLLECTING YOUR INFORMATION:</b> Participants in the
        Ilingnun Ukpigin program may engage in strenuous outdoor activity, which
        some may find physically, emotionally and spiritually demanding. The
        personal and health information you provide will be used only to:
      </Typography>
      <ul>
        <Typography component="li">
          help the program facilitators understand your needs;
        </Typography>
        <Typography component="li">
          support participant safety and wellbeing; and
        </Typography>
        <Typography component="li">
          prepare for and deliver the program activities effectively.
        </Typography>
      </ul>
      <Typography paragraph>
        <b>USE AND DISCLOSURE OF YOUR INFORMATION:</b> Your information may be
        shared with program facilitators and staff of Inuvialuit Regional
        Corporation (IRC) who need the information to operate and deliver the
        program. Information will be shared on a need-to-know basis only.
      </Typography>
      <Typography paragraph>
        <b>STORAGE, RETENTION AND SAFEGUARDS:</b> Your information will be
        stored securely and protected using appropriate physical, administrative
        and electronic safeguards. Information will be kept only as long as
        necessary to fulfill program and legal requirements.
      </Typography>
      <Typography paragraph>
        <b>ACCESS AND CORRECTION:</b> You have the right to request access to
        your personal information and to request corrections if you believe the
        information is inaccurate or incomplete. Requests can be made by
        contacting IT@inuvialuit.com
      </Typography>
      <Typography paragraph>
        <b>ASSUMPTION OF RISK:</b> By collecting this information, IRC does not
        assume any risk on behalf of the participant. Please refer to the
        Participation, Assumption of Risk, Release of Liability and Indemnity
        Agreement for more information.
      </Typography>
    </Box>
  );
}
